import { List, ListItem, ListItemButton, ListItemText, Skeleton, styled } from '@mui/material';
import { Link } from '#components/Link/index.tsx';
import { type MenuItem } from '#components/MainMenu/types.ts';

const MenuContainer = styled('div')({
  borderBottom: '1px solid',
  borderBottomColor: '#111222',
  overflowY: 'scroll',
  width: '100%',
});

export type MenuItemsProps = {
  items: MenuItem[];
  setOpen: (open: boolean) => void;
};

export const MenuItems = ({ items, setOpen }: MenuItemsProps) => {
  return (
    <MenuContainer>
      <List>
        {items.length > 0
          ? items.map(item => (
              <ListItem disablePadding key={item.id}>
                <Link
                  component={ListItemButton}
                  onClick={() => {
                    setOpen(false);
                  }}
                  sx={{ textDecoration: 'none' }}
                  to={item.href}
                >
                  <ListItemText primary={item.label} />
                </Link>
              </ListItem>
            ))
          : Array.from({ length: 10 }).map((_, index) => (
              <ListItem disablePadding key={index}>
                <ListItemButton disabled>
                  <Skeleton sx={{ height: '32px', width: '100%' }} variant="rectangular" />
                </ListItemButton>
              </ListItem>
            ))}
      </List>
    </MenuContainer>
  );
};
